import { Box } from "@mui/material";
import dayjs from "dayjs";
import React from "react";

import { MttAggregatedValues, getAggregatedCellValue } from "./utils";

type AggregatedCellProps = {
  columnId: string;
  aggregated: MttAggregatedValues;
};

export const AggregatedCell = ({ columnId, aggregated }: AggregatedCellProps) => {
  const value = getAggregatedCellValue(columnId, aggregated);

  if (value === "") {
    return null;
  }

  if (columnId === "start_time_ms" && typeof value === "number") {
    return (
      <Box sx={{ fontWeight: 600 }}>
        {value ? dayjs(value).format("DD.MM.YYYY HH:mm") : ""}
      </Box>
    );
  }

  return <Box sx={{ fontWeight: 600 }}>{value}</Box>;
};
